import { gql } from 'graphql-request'

export const RENOMEAR_ITEM = gql`
  mutation RenomearItemMutation($idItemBiblioteca: ID!, $novoNome: String!) {
    renomearItemBiblioteca(
      idItemBiblioteca: $idItemBiblioteca
      novoNome: $novoNome
    ) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
